//#region IMPORT
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSearchText, setYear } from '../../../../Reducer/SearchReducer';
import dayjs from 'dayjs';
/** Components Import */
import { Unstable_Grid2 as Grid, Box, Tabs, Tab } from '@mui/material';
import { AuthButton } from '../../../../Components/MUIs';
import { PropTypes } from 'prop-types';
/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
/** Images Import */
import koshaLogo from '../../../../Assets/Images/kosha-logo.png';

import HEA_BASIC_01F from '../HEA_BASIC_01/HEA_BASIC_01F';
import HEA_BASIC_02F from '../HEA_BASIC_02/HEA_BASIC_02F';
//#endregion

function A11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <React.Fragment>
      {value === index && (
        <Box sx={{ height: '100%', width: '100%' }}>{children}</Box>
      )}
    </React.Fragment>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function HEA_BASIC(props) {
  //#region 변수
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo);
  //#endregion
  //#region 웹

  //#endregion
  //#region 함수

  //#endregion
  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="HealthCheckup"
          saveYn="Y"
          printYn="Y"
          multiPrintYn="Y"
          imageButtonYn="Y"
          imageButtonUrl="https://portal.kosha.or.kr/business-apply-search/biz-support"
          imageButtonSrc={koshaLogo}
          imageButtonAlt="안전보건공단 건강디딤돌"
          imageButtonSx={{
            p: 0.5,
            '& img': {
              maxHeight: '30px',
              maxWidth: '180px',
            },
          }}
          imageButtonTooltip={`건강디딤돌 사업이란?
50인 미만 소규모 사업장의 산업보건 기초제도 이행을 위한 비용 및 사후관리 지원을 통해 사업주 스스로가 근로자의 건강보호 기반을 조성하기 위한 사업`}
          printItem={
            props.value === 0
              ? props.printItem1
              : props.value === 1
                ? props.printItem2
                : []
          }
          deleteClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setDeleteClick1(true);
            } else if (props.value === 1) {
              props.setDeleteClick2(true);
            } else if (props.value === 2) {
              props.setDeleteClick3(true);
            }
          }}
          saveClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setSaveClick1(true);
            } else if (props.value === 1) {
              props.setSaveClick2(true);
            } else if (props.value === 2) {
              props.setSaveClick3(true);
            }
          }}
          printClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setPrintClick1(true);
            } else if (props.value === 1) {
              props.setPrintClick2(true);
            } else if (props.value === 2) {
              props.setPrintClick3(true);
            }
          }}
          searchClick={(e) => {
            if (!props.validateSelection()) return;

            dispatch(setSearchText(e));
            // 현재 탭에 따라 해당 그리드에 필터 적용
            if (props.value === 0 && props.gridRef1.current?.api) {
              props.gridRef1.current.api.setQuickFilter(e);
            } else if (props.value === 1 && props.gridRef1_2.current?.api) {
              props.gridRef1_2.current.api.setQuickFilter(e);
            } else if (props.value === 2 && props.gridRef1_3?.current?.api) {
              props.gridRef1_3.current.api.setQuickFilter(e);
            }
          }}
          conditions={[
            // ADMIN이면 추가 combo
            ...(props.userInfo.authCd === 'ADMIN'
              ? [
                {
                  type: 'combo',
                  name: '회사',
                  items: searchInfo.coList || [],
                  value: searchInfo.coCd || '',
                  onChange: async (e) => {
                    await props.handleCoChange(e);

                    if (props.value === 0) {
                      await props.setSearchClick1(true);
                    } else if (props.value === 1) {
                      await props.setSearchClick2(true);
                    } else if (props.value === 2) {
                      await props.setSearchClick3(true);
                    }
                  },
                },
              ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: searchInfo.custList || [],
              value: searchInfo.custCd || '',
              onChange: async (e) => {
                await props.handleCustChange(e);

                if (props.value === 0) {
                  await props.setSearchClick1(true);
                } else if (props.value === 1) {
                  await props.setSearchClick2(true);
                } else if (props.value === 2) {
                  await props.setSearchClick3(true);
                }
              },
            },
            {
              type: 'datePicker',
              name: '검진연도',
              views: ['year'],
              openTo: 'year',
              value: searchInfo.year ? dayjs(searchInfo.year) : dayjs(),
              onChange: (date) => {
                if (!date || !dayjs(date).isValid()) return;
                dispatch(setYear(dayjs(date).format('YYYY')));
              },
              currentLocale: 'ko',
              format: 'YYYY',
            },
          ]}
          placeholder="검색"
          grids={
            <React.Fragment>
              <Box>
                <Tabs
                  value={props.value}
                  onChange={props.HandleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label="일반건강진단"
                    {...A11yProps(0)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="특수건강진단"
                    {...A11yProps(1)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                </Tabs>
              </Box>
              <CustomTabPanel value={props.value} index={0}>
                <HEA_BASIC_01F
                  gridRef1={props.gridRef1}
                  gridRef2={props.gridRef2}
                  gridRef3={props.gridRef3}
                  rowData1={props.rowData1}
                  setRowData1={props.setRowData1}
                  selectedRowData1={props.selectedRowData1}
                  setSelectedRowData1={props.setSelectedRowData1}
                  changedRowData1={props.changedRowData1}
                  setChangedRowData1={props.setChangedRowData1}
                  HandleManageSelection={props.HandleManageSelection}
                  deletedRowData1={props.deletedRowData1}
                  setDeletedRowData1={props.setDeletedRowData1}
                  selectedRowNosRef1={props.selectedRowNosRef1}
                  lastCheckedIndexRef1={props.lastCheckedIndexRef1}
                  modalRowData1={props.modalRowData1}
                  setModalRowData1={props.setModalRowData1}
                  selectedModalRowData1={props.selectedModalRowData1}
                  setSelectedModalRowData1={props.setSelectedModalRowData1}
                  changedModalRowData1={props.changedModalRowData1}
                  setChangedModalRowData1={props.setChangedModalRowData1}
                  modalToggle1={props.modalToggle1}
                  setModalToggle1={props.setModalToggle1}
                  rowClickData={props.rowClickData}
                  excelData={props.excelData}
                  setExcelData={props.setExcelData}
                  fileInputRef={props.fileInputRef}
                  validateSelection={props.validateSelection}
                  PopupClickEvent1={props.PopupClickEvent1}
                  SaveLogic2={props.SaveLogic2}
                  handleRowSelection1={props.handleRowSelection1}
                  MarkedForDeletion1={props.MarkedForDeletion1}
                  RestoreRow1={props.RestoreRow1}
                  ExcelDownload={props.ExcelDownload}
                  NewYnErrorMsg={props.NewYnErrorMsg}
                  DeleteNewRow1={props.DeleteNewRow1}
                  saveClick1={props.saveClick1}
                  setSaveClick1={props.setSaveClick1}
                  searchClick1={props.searchClick1}
                  setSearchClick1={props.setSearchClick1}
                  printClick1={props.printClick1}
                  setPrintClick1={props.setPrintClick1}
                  printClick1Guideline={props.printClick1Guideline}
                  setPrintClick1Guideline={props.setPrintClick1Guideline}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={1}>
                <HEA_BASIC_02F
                  gridRef1_2={props.gridRef1_2}
                  gridRef2={props.gridRef2}
                  gridRef3={props.gridRef3}
                  validateSelection={props.validateSelection}
                  PopupClickEvent1={props.PopupClickEvent1}
                  SaveLogic2={props.SaveLogic2}
                  handleRowSelection1={props.handleRowSelection1}
                  ExcelDownload={props.ExcelDownload}
                  NewYnErrorMsg={props.NewYnErrorMsg}
                  HandleManageSelection={props.HandleManageSelection}
                  modalRowData1={props.modalRowData1}
                  setModalRowData1={props.setModalRowData1}
                  selectedModalRowData1={props.selectedModalRowData1}
                  setSelectedModalRowData1={props.setSelectedModalRowData1}
                  changedModalRowData1={props.changedModalRowData1}
                  setChangedModalRowData1={props.setChangedModalRowData1}
                  modalToggle1={props.modalToggle1}
                  setModalToggle1={props.setModalToggle1}
                  rowClickData={props.rowClickData}
                  excelData={props.excelData}
                  setExcelData={props.setExcelData}
                  fileInputRef={props.fileInputRef}
                  searchClick2={props.searchClick2}
                  setSearchClick2={props.setSearchClick2}
                  saveClick2={props.saveClick2}
                  setSaveClick2={props.setSaveClick2}
                  printClick2={props.printClick2}
                  setPrintClick2={props.setPrintClick2}
                  printClick2Guideline={props.printClick2Guideline}
                  setPrintClick2Guideline={props.setPrintClick2Guideline}
                />
              </CustomTabPanel>
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}

export default HEA_BASIC;
